// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dWro","tabsBox":"styles_tabsBox__6eJRD","createButton":"styles_createButton__3o16r"};